import React from "react";

const TeamIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-users-round fill-current"
    >
      <path d="M18 21a8 8 0 0 0-16 0"></path>
      <circle cx="10" cy="8" r="5"></circle>
      <path d="M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3"></path>
    </svg>
  );
};

export default TeamIcon;
